import { createContext } from "react";

export const RTrContext = createContext({
  isFirstRow: false,
  isLastRow: false,
});
